import { dao } from '@platform/dao';
import type { IWorkspaceWrite } from '@platform/dao';
import type { ISavedView, ISavedViewWrite, ITag, ITagWrite, ITreeNode, IUserRef, IWorkspace, IWorkspaceMember } from '@platform/core/types';
import { baseApi, run } from './baseApi';

export const workspaceApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    myWorkspaces: b.query<IWorkspace[], void>({ queryFn: () => run(() => dao.workspaces.mine()), providesTags: ['Workspaces'] }),
    createWorkspace: b.mutation<IWorkspace, IWorkspaceWrite>({ queryFn: (body) => run(() => dao.workspaces.create(body)), invalidatesTags: ['Me', 'Workspaces'] }),
    workspace: b.query<IWorkspace, string>({ queryFn: (id) => run(() => dao.workspaces.get(id)), providesTags: (_r, _e, id) => [{ type: 'Workspaces', id }] }),
    members: b.query<IWorkspaceMember[], string>({ queryFn: (id) => run(() => dao.workspaces.members(id)), providesTags: (_r, _e, id) => [{ type: 'Workspaces', id: `members:${id}` }] }),
    searchUsers: b.query<IUserRef[], { ws: string; q: string }>({ queryFn: ({ ws, q }) => run(() => dao.workspaces.searchUsers(ws, q)) }),
    tags: b.query<ITag[], string>({ queryFn: (id) => run(() => dao.workspaces.tags(id)), providesTags: (_r, _e, id) => [{ type: 'Tags', id }] }),
    createTag: b.mutation<ITag, { ws: string; body: ITagWrite }>({
      queryFn: ({ ws, body }) => run(() => dao.workspaces.createTag(ws, body)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Tags', id: ws }],
    }),
    areas: b.query<ITreeNode[], string>({ queryFn: (id) => run(() => dao.workspaces.areas(id)), providesTags: (_r, _e, id) => [{ type: 'Paths', id: `areas:${id}` }] }),
    iterations: b.query<ITreeNode[], string>({ queryFn: (id) => run(() => dao.workspaces.iterations(id)), providesTags: (_r, _e, id) => [{ type: 'Paths', id: `iterations:${id}` }] }),
    views: b.query<ISavedView[], { ws: string; recordType?: string }>({
      queryFn: ({ ws, recordType }) => run(() => dao.workspaces.views(ws, recordType)),
      providesTags: (_r, _e, { ws }) => [{ type: 'Views', id: ws }],
    }),
    saveView: b.mutation<ISavedView, { ws: string; body: ISavedViewWrite; viewId?: string }>({
      queryFn: ({ ws, body, viewId }) => run(() => dao.workspaces.saveView(ws, body, viewId)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Views', id: ws }],
    }),
    deleteView: b.mutation<void, { ws: string; viewId: string }>({
      queryFn: ({ ws, viewId }) => run(() => dao.workspaces.deleteView(ws, viewId)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Views', id: ws }],
    }),
  }),
});

export const {
  useMyWorkspacesQuery, useCreateWorkspaceMutation, useWorkspaceQuery, useMembersQuery, useSearchUsersQuery, useTagsQuery, useCreateTagMutation,
  useAreasQuery, useIterationsQuery, useViewsQuery, useSaveViewMutation, useDeleteViewMutation,
} = workspaceApi;
